import './details';
import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from '../src/dbh_helper';

if (dbh_helper.getUrlArea() == "listen") {
    $(document).ready(function () {

    });
}